import { render, staticRenderFns } from "./Kementriandanlembaga.vue?vue&type=template&id=24dc7a91"
import script from "./Kementriandanlembaga.vue?vue&type=script&lang=js"
export * from "./Kementriandanlembaga.vue?vue&type=script&lang=js"
import style0 from "./Kementriandanlembaga.vue?vue&type=style&index=0&id=24dc7a91&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports